export const getBackofficeV2Link = (path: string) => {
  const _host = process.env.REACT_APP_BACKOFFICE_V2 ?? 'invalid host'
  return _host.concat(path)
}
